import {
    FETCH_SUGGESTED_DOMAINS_REQUEST,
    FETCH_SUGGESTED_DOMAINS_SUCCESS,
    FETCH_SUGGESTED_DOMAINS_FAILURE,
    FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_REQUEST,
    FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_SUCCESS,
    FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_FAILURE,
    UPDATE_SUGGESTED_DOMAINS_REQUEST,
    UPDATE_SUGGESTED_DOMAINS_PARTIAL_SUCCESS,
    UPDATE_SUGGESTED_DOMAINS_FAILURE
} from '../actions/types/suggested-domains-action-types';

import { combineReducers } from 'redux';
import { CLOSE_RIGHT_PANE } from '../actions/types/ui-state-action-types';

function allIds( state = [], action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_REQUEST:
            if( action.params.pageNum === 1 ){
                newState = [];
            }
            else{
                newState = state;
            }
            break;
        case FETCH_SUGGESTED_DOMAINS_SUCCESS:
            newState = state.concat( action.allIds );
            break;
        case FETCH_SUGGESTED_DOMAINS_FAILURE:
            newState = [];
            break;
        default:
            return state;
    }

    return newState;
}

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_SUCCESS:
            newState = { ...state, ...action.byId };
            break;
        case FETCH_SUGGESTED_DOMAINS_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function domainErrors( state = null, action ){
    let newState;
    switch( action.type ){
        case UPDATE_SUGGESTED_DOMAINS_REQUEST:
        case UPDATE_SUGGESTED_DOMAINS_FAILURE:
        case CLOSE_RIGHT_PANE:
            newState = null;
            break;
        case UPDATE_SUGGESTED_DOMAINS_PARTIAL_SUCCESS:
            newState = action.domainErrors;
            break;
        default:
            newState = state;
    }

    return newState;
}

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_REQUEST:
            newState = true;
            break;
        case FETCH_SUGGESTED_DOMAINS_SUCCESS:
        case FETCH_SUGGESTED_DOMAINS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}
function filterParams( state = null, action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_REQUEST:
            newState = action.filters;
            break;
        case FETCH_SUGGESTED_DOMAINS_FAILURE:
            newState = null;
            break;
        default:
            return state;
    }

    return newState;
}
function params( state = null, action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_REQUEST:
            newState = action.params;
            break;
        case FETCH_SUGGESTED_DOMAINS_FAILURE:
            newState = null;
            break;
        default:
            return state;
    }

    return newState;
}
function orgDomains( state = [], action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_SUCCESS:
            newState = action.orgDomains;
            break;
        default:
            return state;
    }

    return newState;
}
function orgDomainsIsLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_REQUEST:
            newState = true;
            break;
        case FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_SUCCESS:
        case FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}
function orgDomainsParams( state = null, action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_REQUEST:
            newState = action.params;
            break;
        case FETCH_SUGGESTED_DOMAINS_ORG_DOMAINS_FAILURE:
            newState = null;
            break;
        default:
            return state;
    }

    return newState;
}
function pagination( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_SUGGESTED_DOMAINS_SUCCESS:
            newState = action.pagination;
            break;
        case FETCH_SUGGESTED_DOMAINS_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}


export default combineReducers( {
    allIds,
    byId,
    domainErrors,
    filterParams,
    isLoading,
    orgDomains,
    orgDomainsIsLoading,
    orgDomainsParams,
    pagination,
    params,
} );
